<template>
  <div>

    <transition name="modal-fade-scale">
      <app-modal
        v-if="open"
        class="popup"
      >
        <app-modal-default unpadded @close="closePopup" class="fert-popup">
          <template v-slot:header>
            {{ general.name ? general.name : $ml.get(`New fertilizer`) }}
          </template>
          <template v-slot:content>
            <form @submit="submitForm" class="content">
              <General :general="general"/>
              <!-- {{general}} -->
              <template v-if="state">

                <template v-if="state == 'solid'">
                  <LineMy />
                  <Solubility :general="general" />
                </template>

                <template>
                  <LineMy />
                  <Nutrients :general="general"/>
                </template>


                <template>
                  <LineMy />
                  <Microelements :general="general" />
                </template>

                <LineMy />

                <div class="errors">

                  <template>
                    <p v-if="(general.stateId == 1 || general.stateId == 2) && disabled">
                      {{ $ml.get('Please enter value to any of nutrients') }}
                    </p>
                  </template>

                  <template v-if="general.stateId == 3 || general.stateId == 4">
                    <p v-if="!general.data.SpecificWeight">
                      {{ $ml.get('Density should be more than 0') }}
                    </p>
                  </template>

                  <template v-if="general.stateId == 5 || general.stateId == 6">
                    <p v-if="!general.data.maximumAvailability && !$store.getters['fertilizers/popup/isNew']">
                      {{ $ml.get('Maximum availability should be more than 0') }}
                    </p>
                    <p v-if="!general.maximumAvailability && $store.getters['fertilizers/popup/isNew']">
                      {{ $ml.get('Maximum availability should be more than 0') }}
                    </p>
                    <p v-if="!general.data['ElementsConcentration']['NH2_Val']">
                      {{ $ml.get('NNH2 should be more than 0') }}
                    </p>
                  </template>

                  <template v-if="state == 'acid'">
                    <p v-if="!general.data.NumberOfH">
                      {{ $ml.get('Number of H should be more than 0') }}
                    </p>
                    <p v-if="!general.data.MolecularWeight">
                      {{ $ml.get('Molecular weight should be more than 0') }}
                    </p>
                  </template>

                  <template v-if="total">
                    <p v-if="!general.data.NumberOfH">
                      {{ $ml.get('Sum of nutriens should be less than 100%') }}
                    </p>
                  </template>

                </div>

                <app-btn
                  class="save-button"
                  type="submit"
                  :disabled="disabled || total"
                >
                  {{$ml.get(`save`)}}
                </app-btn>



              </template>

            </form>
          </template>
        </app-modal-default>
      </app-modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import General from './General.vue';
import Solubility from './Solubility.vue';
import Nutrients from './Nutrients.vue';
import Microelements from './Microelements.vue';
import LineMy from './helps/Line.vue';

export default {
  computed: {
    ...mapGetters({
      general: 'fertilizers/popup/general',
      open: 'fertilizers/popup/open',
      state: 'fertilizers/popup/state',
      disabled: 'fertilizers/popup/disableSave',
      errors: 'fertilizers/popup/errors',
    }),
    total() {
      let nutrients = 0
      for(let nut in this.general.data.ElementsConcentration){
        if(!['N_Val', 'B_Val', 'Fe_Val', 'Mn_Val', 'Zn_Val', 'Cu_Val', 'Mo_Val', 'F_Val'].includes(nut))
          nutrients += this.general.data.ElementsConcentration[nut]
      }
      return nutrients > 100 ? true : false
    }
  },
  watch: {
    general: {
      deep: true,
      handler(val) {
        this.$store.dispatch('fertilizers/popup/validFertilizer');
        // console.log('watch');
      }
    }
  },
  methods: {
    closePopup () {
      this.$store.dispatch('fertilizers/popup/open', {open: false});
      this.$store.commit('fertilizers/popup/setState', null);
    },
    submitForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.save();
    },
    save() {
      if (!this.check())
        return false;

      if (this.state != 'acid') {
        this.general.data.NumberOfH = 0;
        this.general.data.MolecularWeight = 0;
      }

      this.$store.dispatch('fertilizers/popup/save').then(res => {
        if (res.data.success == true) {
          // this.$notify({
          //   group: 'notices',
          //   title: `Fertilizer successfully added!`,
          //   type : 'Success',
          // });

          if (this.$store.getters['fertilizers/popup/isNew']) {
            this.$store.dispatch('fertilizers/getFertilizers').then(res_2 => {
              this.$store.commit('fertilizers/savePage', this.$store.getters['fertilizers/getPageCount'] - 1);
              this.$router.push('/dashboard/fertilizers/all/' + res.data.data.id);
            });
          } else {
            this.$store.dispatch('fertilizers/getFertilizer');
          }
          this.closePopup();
        }
         try {
              let result = JSON.parse(JSON.stringify(res));
              if (result.data.message == 'Please buy a plan!') {
                this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before creating fertilizers.`
                  ),
                  type: "error",
                });
              }
            } catch (e) {}
      }).catch(err => {
        // this.$notify({
        //   group: 'notices',
        //   title: `An error occurred`,
        //   type : 'Error',
        // });
      });
    },
    check () {
      var micro = ['B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo'];
      var res_micro = 0;
      var res_nut = 0;
      var flag = true;

      for (var key in this.general.data.ElementsConcentration) {
        res_nut += Number(this.general.data.ElementsConcentration[key]);
      }
      for (var key of micro) {
        res_micro += Number(this.general.data.ElementsConcentration[key+'_Val']);
      }
      if (this.general.data.MicroElementsChelated && res_micro <= 0) {
        flag = false;
        this.$store.commit('modals/prompt/open', {
          text: this.$ml.get(`You marked microelements are cheated, install microelements`),
        });
      } else if (res_nut <= 0) {
        flag = false;
        if(this.state == 'acid') {
          flag = true;
          return flag;
        }
        this.$store.commit('modals/prompt/open', {
          text: this.$ml.get(`No nutrient has been added; enter at least one nutrient`),
        });
      } else if (this.general.data.ElementsConcentration['N_Val'] > 100) {
        flag = false;
        this.$store.commit('modals/prompt/open', {
          text: this.$ml.get(`Total nutrients should not exceed 100%`),
        });
      }


      return flag;
    }
  },
  components: {
    Microelements,
    Nutrients,
    Solubility,
    General,
    LineMy
  }
}
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;

  .fert-popup {
    width: 90vw;

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      // align-items: center;
      padding: 14px;
      padding-bottom: 40px;
      box-sizing: border-box;
      .errors {
        p {
          color: #EC5A60;
        }
      }
      .save-button {
        width: 166px;
      }
    }
  }
}
</style>
